import React, {useEffect, useRef, useState} from 'react';
import "./onboard-date-style.scss";
import Inputmask from "inputmask";
import parse from 'html-react-parser';
import IconTooltip from "./images/date-picker-icon.svg";

const OnboardDate = (props) => {

    const {validation, error, value, onChange, placeholder, disabled} = props;
    const inputRef = useRef();

    const [mValue, setMValue] = useState(value != null ? value : "");
    const [mError, setMError] = useState(error);
    const [mValid, setMValid] = useState(mValue.length > 0 ? validation : null);

    useEffect(() => {
        setMError(error);
    }, [error]);

    useEffect(() => {
        setMValue(value != null ? value : "");
    }, [value]);

    useEffect(() => {
        if (mValue.length > 0) {
            setMValid(validation);
        } else {
            setMValid(null);
        }
    }, [validation]);

    const handleChange = (val) => {
        let text = val.target.value;
        if (error !== undefined) {
            setMError(null);
        }
        if (validation !== undefined) {
            if (mValid == null)
                setMValid(null);
        }
        setMValue(text);
        if (onChange !== undefined)
            onChange(text);
    }

    useEffect(() => {
        setMask();
        if (mValue !== undefined && mValue != null && mValue.length > 0) {
            inputRef.current.value = parse(mValue);
        }
    }, [])

    const setMask = () => {//mask: "99 / 99 / 9999",
        Inputmask({
            regex: "^(0[1-9]|1\\d|2\\d|3[01])\\/(0[1-9]|1[0-2])\\/(1|2)\\d{3}$",
            greedy: true
        }).mask(inputRef.current);
    }

    return (
        <div className="onboard-date-root">
            <div className="onboard-date-inp">
                <input ref={inputRef}
                       type="text"
                       placeholder="&nbsp;"
                       value={parse(mValue)}
                       onChange={(e) => handleChange(e)}
                       disabled={disabled}
                       className={(mError || mValid) ? 'onboard-date-error' : ''}
                >
                </input>
                <div className={"onboard-date-label " +
                    ((mError || mValid) ? 'onboard-date-error-label' : '')
                }>
                    {placeholder}
                </div>
                <img alt={"logo"} src={IconTooltip} className="onboard-date-icon-date"/>
                <span className="onboard-date-focus-bg"></span>
                {mError && (<div className="onboard-date-error-hint">{mError}</div>)}
                {(!mError && mValid) && (<div className="onboard-date-error-hint">{mValid}</div>)}
            </div>
        </div>
    )
};

export default OnboardDate;
